export const INQUIRY = '/inquiry/' as const
export const INQUIRY_ALL = `${INQUIRY}all` as const
export const INQUIRY_CREATE = `${INQUIRY}` as const
export const INQUIRY_DELETE = `${INQUIRY}` as const
export const INQUIRY_UPDATE_STATUS = `${INQUIRY}update-status` as const
export const INQUIRY_ASSIGNED = `${INQUIRY}assigned` as const
export const INQUIRY_COMMENT = `${INQUIRY}comment-template/` as const
export const INQUIRY_PUBLIC_INFO = '/public/inquiry' as const
